import { render, staticRenderFns } from "./OrderCardHead.vue?vue&type=template&id=354b5af1&"
import script from "./OrderCardHead.vue?vue&type=script&lang=js&"
export * from "./OrderCardHead.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardHead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports